module.exports = __webpack_public_path__ + "static/img/Star.1f979f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/Star.png
// module id = 9ETb
// module chunks = 1